import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography } from '@mui/material';

export default function IframeMeeting() {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, md: 8 },
        bgcolor: 'white',
        position: 'relative',
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 2,
        }}
      >
        {/* Header Section */}
        <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 5 } }}>
          <Typography
            variant="h2"
            sx={{
              fontFamily: 'Barlow, sans-serif',
              fontSize: { xs: '2rem', sm: '2.5rem', md: '2.8rem' },
              fontWeight: 800,
              lineHeight: 1.2,
              color: '#1a202c',
              mb: 2,
            }}
          >
            {t("BannerScheduleMeeting00")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: 'Barlow, sans-serif',
              fontSize: { xs: '1rem', md: '1.1rem' },
              color: '#4a5568',
              lineHeight: 1.6,
              maxWidth: 600,
              mx: 'auto',
            }}
          >
            {t("IframeHubspotMeeting01")}
          </Typography>
        </Box>

        {/* Iframe Container */}

        <iframe
          src="https://meetings-eu1.hubspot.com/gabriel-roman-bennassar?embed=true"
          style={{
            width: '100%',
            height: '700px',
            border: '0',
            display: 'block',
          }}
          title={t('IframeHubspotMeeting02')}
        />
      </Container>
    </Box>
  );
}